<template>
  <div class="renew3_payment">

    <!-- PC左 -->
    <div class="how2">

      <!--ヤギプライムに加入チェック-->
      <div class="yagiprime_check" v-if="is_simultaneous">
        <div class="check_block">
          <label for="yagiprime_checkbox">
            <input type="checkbox" id="yagiprime_checkbox" />ヤギプライムに加入して<span class="red_color">使い放題</span>
          </label>
          <p class="t_amount">月額 550円(税込)</p>
        </div>

        <p class="t_terms">
          <img src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック" class="check_icon">
          <a href="/yagiprimeterms" target="_blank">ヤギプライム利用規約</a>に同意する
        </p>
      </div>

      <div class="payment_common">
        <ul class="payment_list">
          <li class="payment_item">
            <div class="p_title">
              <input type="radio" id="how_payment1" name="how_payment" value="card" v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'card' }"
                for="how_payment1">クレジットカードで支払う</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'card'">
              <div class="card_form">
                <CardPayment ref="cardPayment" @payment-success="handlePaymentSuccess"
                  @payment-error="handlePaymentError" :onValidationChange="handleValidationChange"
                  :isSubscription="is_subscription" :amount="price" :selectedIndex="selectedIndex" :notificationSetting="notificationSetting" />
              </div>
              <div class="memo">
                <p class="red_color">※お客様のカード情報は保存されません。</p>
                <p class="red_color">※Visa・MasterCard・American Express・JCB・Diners Club・Discoverのクレジットカードがご利用可能です。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-card-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button class="payment-card-btn" :id="'yagiprime-payment-' + currentPathEnd"
                    :disabled="!isCardFormValid || isCardButtonDisabled"
                    @click="handleCardPayment">クレジットカードで登録する</button>
                </template>
              </div>
            </div>
          </li>

          <li class="payment_item">
            <div class="p_title">
              <input type="radio" id="how_payment2" name="how_payment" value="paypay" v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'paypay' }"
                for="how_payment2">PayPayで支払う</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'paypay'">
              <div class="memo">
                <p class="red_color">※PayPayアプリでの連携後、自動で決済が行われます。決済成功後、マイページにて登録状態を確認できます。</p>
                <p class="red_color">※yagishに戻っても画面が変わらない場合はリロードしてみてください。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-paypay-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button :id="'yagiprime-payment-' + currentPathEnd" class="payment-paypay-btn" @click="paypayPayment">
                    <img src="/static/renew2_img/paypay_payment_lg.png" class="paypay-btn-img">
                  </button>
                </template>
              </div>
            </div>
          </li>

          <li class="payment_item" v-if="isApplePayAvailable">
            <div class="p_title">
              <input type="radio" id="how_payment3" name="how_payment" value="applepay"
                v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'applepay' }" for="how_payment3">Apple
                Payで支払う</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'applepay'">
              <div class="memo">
                <p class="red_color">※Apple Payでの支払いが選択されています。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-applepay-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <div v-if="isDisplayApplePayButton" id="payment-request-button"></div>
                  <div v-else class="skeleton-loader">
                    <div class="skeleton skeleton-button"></div>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="merit" v-if="is_subscription">
        <!--ヤギプライムに関する注意事項-->
        <div class="yagiprime_note">
          <h3 class="yagiprime_note-h3">ヤギプライムに関する注意事項</h3>
          <ul class="yagiprime_note-list">
            <li class="yagiprime_note-item">
              <p class="item-left">販売価格</p>
              <p class="item-txt">30日間ごとに550円(税込)となります。通信等にかかる費用は別途お客様のご負担となります。</p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">支払い時期及びサービスの開始時期</p>
              <p class="item-txt">
                本サービスにお申込みいただき、お客様の登録が完了した時点でクレジットカードによりご利用代金が引き落とされると同時に、サービスが開始されます。初回のサービス提供期間終了後、自動更新され、お客様の選択により、以降30日間ごとに550円（税込）がかかります。利用代金は更新されたサービス期間の初日に登録されたクレジットカードまたはPayPayから引き落とされます。
              </p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">支払方法</p>
              <p class="item-txt">クレジットカード（Visa・MasterCard・American Express・JCB・Diners
                Club・Discover）をご利用いただけます。</p>
              <p class="item-txt">PayPayをご利用いただけます。</p>
            </li>
            <li class="yagiprime_note-item">
              <p class="item-left">契約の申し込みの撤回又は解除</p>
              <p class="item-txt">
                お申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--PC右 金額-->
    <!-- <div class="payment_amount" v-if="!is_simultaneous">
      <div class="a-title">
        <p>{{ serviceName }}</p>
        <p><span v-if="is_subscription">月額</span><span class="red_color">{{ price }}円</span>(税込)</p>
      </div>
      <div class="">
        <div class="payment-btn" v-if="selectedPaymentMethod === 'card'">
          <button class="payment-card-btn" :id="'yagiprime-payment-'+currentPathEnd" :disabled="!isCardFormValid || isCardButtonDisabled"
            @click="handleCardPayment">クレジットカードで登録する</button>
        </div>
        <div class="payment-btn" v-if="selectedPaymentMethod === 'paypay'">
          <button :id="'yagiprime-payment-' + currentPathEnd" class="payment-paypay-btn" @click="paypayPayment">
            <img src="/static/renew2_img/paypay_payment_lg.png" class="paypay-btn-img">
          </button>
        </div>
        <div class="payment-btn" v-if="selectedPaymentMethod === 'applepay'">
          <div v-if="!isDisplayApplePayButton" class="skeleton-loader">
            <div class="skeleton skeleton-button"></div>
          </div>
          <div v-else id="payment-request-button"></div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import CardPayment from './CardPayment.vue'
import { loadStripe } from '@stripe/stripe-js'
import VueCookies from 'vue-cookies'
import {
  YAGIPRIME_ENTRY_POINTS,
  markYagiprimePurchasePending
} from '@/composables/useYagiprimePurchaseTracking'

export default {
  components: {
    CardPayment
  },
  props: {
    is_simultaneous: {
      type: Boolean,
      default: false
    },
    serviceName: {
      type: String,
      default: 'メール便'
    },
    price: {
      type: Number,
      default: 330
    },
    is_subscription: {
      type: Boolean,
      default: false
    },
    selectedIndex: {
      type: Number,
      default: 1
    },
    // GA4 のヤギプライム purchase をどの入口として計上するか
    trackingEntryPoint: {
      type: String,
      default: YAGIPRIME_ENTRY_POINTS.main,
      validator: (value) =>
        Object.keys(YAGIPRIME_ENTRY_POINTS).indexOf(value) !== -1
    },
    notificationSetting: {
      type: String,
      default: 'on'
    }
  },
  data () {
    return {
      selectedPaymentMethod: 'card', // デフォルトの支払方法
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      isCardFormValid: false,
      isApplePayAvailable: false,
      paymentRequest: null,
      isDisplayApplePayButton: false,
      isCardButtonDisabled: false
    }
  },
  computed: {
    currentPathEnd () {
      // URLパスを取得
      const path = window.location.pathname
      // パスを'/'で分割して配列にする
      const pathParts = path.split('/')
      // 空の要素を除去
      const filteredParts = pathParts.filter(part => part)
      // 最後の要素を返す
      return filteredParts.length > 0 ? filteredParts[filteredParts.length - 1] : ''
    }
  },
  methods: {
    handlePaymentSuccess (paymentData) {
      console.log('支払い情報:', paymentData)
      this.isCardButtonDisabled = false

      // 決済成功イベントを発行
      this.$eventHub.$emit('payment_yagiprime_result', 'success')

      // 成功メッセージを表示
      this.$message({
        message: '決済が完了しました。',
        type: 'success'
      })
    },
    handlePaymentError (error) {
      console.error('支払いエラー:', error)

      // エラーメッセージを取得（具体的なエラーメッセージがある場合はそれを使用）
      let errorMessage = '支払いに失敗しました。'
      if (error && error.message) {
        errorMessage = error.message
      }

      this.$message({
        message: errorMessage,
        type: 'error'
      })
      this.isCardButtonDisabled = false
    },
    handleValidationChange (isValid) {
      this.isCardFormValid = isValid
    },
    handleCardPayment () {
      if (this.$firebase.user && this.$firebase.user.email && this.$firebase.user.email.indexOf('@privaterelay.appleid.com') !== -1) {
        this.$eventHub.$emit('show-private-relay-warning', () => { this.executeCardPayment() })
        return
      }
      this.executeCardPayment()
    },
    // ヤギプライム決済のときだけ GA4 purchase 用の文脈を残す
    // （メール便等の単発決済はこのコンポーネントの計測対象外）
    markYagiprimePending(paymentMethod) {
      if (!this.is_subscription) {
        return
      }
      markYagiprimePurchasePending({
        entryPoint: this.trackingEntryPoint,
        subscriptionType: this.selectedIndex,
        paymentMethod,
        price: this.price,
        screenPath: this.currentPathEnd
      })
    },
    executeCardPayment () {
      this.isCardButtonDisabled = true
      if (this.selectedPaymentMethod === 'card' && this.isCardFormValid) {
        this.markYagiprimePending('card')
        // `CardPayment` コンポーネントの `processPayment` メソッドを呼び出す
        this.$refs.cardPayment.createToken()
      } else {
        alert('カード情報が無効です')
      }
    },
    paypayPayment () {
      if (this.$firebase.user && this.$firebase.user.email && this.$firebase.user.email.indexOf('@privaterelay.appleid.com') !== -1) {
        this.$eventHub.$emit('show-private-relay-warning', () => { this.executePaypayPayment() })
        return
      }
      this.executePaypayPayment()
    },
    executePaypayPayment () {
      if (this.is_subscription) {
        this.yagiprimePaypay()
      } else {
        // 親コンポーネントの処理を呼び出す
        this.$emit('paypay-payment')
      }
    },
    yagiprimePaypay: function (param) {
      const app = this
      // app.fullscreenLoading = true
      app.$eventHub.$emit('loading_on')
      // PayPay は外部リダイレクトを挟むので、復帰後に金額と入口を復元できるようにしておく
      this.markYagiprimePending('paypay')

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', this.selectedIndex)
      formData.append('notification_setting', this.notificationSetting)

      const routeId = VueCookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        formData.append('route', routeId)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)
      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url)
          location.href = response.data.authorization_url
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          // app.fullscreenLoading = false
          app.$eventHub.$emit('loading_off')
        })
    },
    async initializeExpressCheckout () {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = this.price
      const CURRENCY = 'jpy'
      const LABEL = this.serviceName

      // Apple Pay の paymentRequest を作成または取得
      if (!this.paymentRequest) {
        this.paymentRequest = stripe.paymentRequest({
          country: 'JP',
          currency: CURRENCY,
          total: {
            label: LABEL,
            amount: AMOUNT
          },
          requestPayerName: true,
          requestPayerEmail: true
        })

        // Apple Pay が利用可能か確認
        const result = await this.paymentRequest.canMakePayment()
        this.isApplePayAvailable = !!(result && result.applePay)
      }
    },
    async applePayMount () {
      if (this.$firebase.user && this.$firebase.user.email && this.$firebase.user.email.indexOf('@privaterelay.appleid.com') !== -1) {
        this.$eventHub.$emit('show-private-relay-warning', () => { this.executeApplePay() })
        return
      }
      this.executeApplePay()
    },
    async executeApplePay () {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = this.price
      const LABEL = this.serviceName
      const CURRENCY = 'jpy'
      // モードを指定 this.subscriptionがtrueの場合はsubscription、falseの場合はpayment
      const mode = this.is_subscription ? 'subscription' : 'payment'
      const elements = stripe.elements({
        mode,
        amount: AMOUNT,
        currency: CURRENCY
      })

      const customerForm = new FormData()
      customerForm.append('uuid', this.$firebase.user.uid)
      customerForm.append('subscription_type', 1)
      customerForm.append('notification_setting', this.notificationSetting)
      const routeId = VueCookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        customerForm.append('route', routeId)
      } else {
        customerForm.append('route', '')
      }

      if (this.is_subscription) {
        console.log('Customerの作成開始')
        const response = await this.$axios.post(this.$varuna.endPoints.createStripeCustomer, customerForm)
        console.log('Customerの作成成功:', response.data.success)
        console.log('IncompleteSubscriptionの作成成功:', response.data.client_secret)
        this.clientSecret = response.data.client_secret
      } else { }

      this.isDisplayApplePayButton = true
      const applePayButton = this.is_subscription ? 'subscribe' : 'buy'
      this.expressCheckoutElement = elements.create('expressCheckout', {
        paymentRequest: this.paymentRequest,
        buttonType: {
          applePay: applePayButton
        }
      })

      this.$nextTick(() => {
        this.expressCheckoutElement.mount('#payment-request-button')
      })

      this.expressCheckoutElement.on('click', async (e) => {
        const options = this.is_subscription
          ? {
              clientSecret: this.clientSecret,
              applePay: {
                recurringPaymentRequest: {
                  paymentDescription: LABEL,
                  regularBilling: {
                    amount: AMOUNT,
                    label: LABEL,
                    recurringPaymentIntervalUnit: 'day',
                    recurringPaymentIntervalCount: 30
                  },
                  billingAgreement:
                '30日間ごとに550円(税込)となります。\n本サービスにお申込みいただき、お客様の登録が完了した時点でご利用代金が引き落とされると同時に、サービスが開始されます。\n初回のサービス提供期間終了後、自動更新され、お客様の選択により、以降30日間ごとに550円（税込）がかかります。\n利用代金は更新されたサービス期間の毎初日に登録された決済情報から引き落とされます。\nお申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。',
                  managementURL: 'https://rirekisho.yagish.jp/mypage/account'
                }
              }
            }
          : {}
        if (!this.is_subscription) {
        }

        e.resolve(options)
      })

      this.expressCheckoutElement.on('confirm', async (event) => {
        try {
          if (this.is_subscription) {
            console.log('フォームのデータを送信開始')
            const { error: submitError } = await elements.submit()
            if (submitError) {
              console.error('フォーム送信エラー:', submitError)
              this.$message({
                message: submitError.message,
                type: 'error'
              })
              event.complete('fail')
              return
            }
            console.log('PaymentIntentの確認開始')
            // リダイレクト復帰後（checkStripeRedirect）に purchase を送るための文脈
            this.markYagiprimePending('apple_pay')
            const { error: confirmError } = await stripe.confirmPayment({
              elements,
              clientSecret: this.clientSecret,
              confirmParams: {
                return_url: window.location.href
              }
            })

            if (confirmError) {
              console.error('決済エラー:', confirmError)
              this.$message({
                message: confirmError.message || '決済に失敗しました。',
                type: 'error'
              })
              event.complete('fail')
            } else {
              console.log('決済処理が開始されました（リダイレクト予定）')
              // リダイレクトが発生するため、ここでは成功イベントは発行しない
              // リダイレクト後にbeforeMountで処理される
              event.complete('success')
            }
          } else {
            const confirmationToken = event.confirmationToken
            console.log('confirmationToken:', confirmationToken)
            // 非サブスクリプションの場合の処理
            event.complete('success')
          }
        } catch (error) {
          console.error('支払いエラー:', error)
          this.$message({
            message: '支払いに失敗しました。',
            type: 'error'
          })
          event.complete('fail')
        }
      })
    }
  },
  async mounted () {
    if (this.is_subscription) {
      await this.initializeExpressCheckout()
    }
  },
  watch: {
    selectedPaymentMethod (newVal) {
      console.log(this.isDisplayApplePayButton)
      if (newVal === 'applepay') {
        this.applePayMount()
      } else {
        this.isDisplayApplePayButton = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.renew3_payment {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  /*ヤギプライムに加入チェック*/
  .yagiprime_check {
    border: 2px solid #8fbd67;
    border-radius: 10px;
    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));
    background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));
    padding: 15px;
    margin-bottom: 20px;
  }

  .red_color {
    color: #E3165C;
  }

  .how2 {
    margin-right: 20px;
  }

  .payment_common {
    .payment_list {
      .payment_item {
        .payment-btn {
          min-height: 50px;
          height: 50px;
          text-align: center;
          width: auto;

          .payment-card-btn {
            background: #E3165C;
            color: #fff;
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            font-weight: bold;

            &:disabled {
              background: #dfdfdf;
            }

            &:disabled:hover {
              cursor: not-allowed;
              background: #dfdfdf;
              opacity: 1;
            }
          }

          .payment-paypay-btn {
            background: #FF0033;
            color: #fff;
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            font-weight: bold;

            .paypay-btn-img {
              max-height: 49px;
              max-width: 98%;
            }
          }
        }
      }
    }
  }
}

.renew3_payment .yagiprime_check .check_block {
  margin-bottom: 20px;
}

.renew3_payment .yagiprime_check label,
.renew3_payment .yagiprime_check input[type='checkbox'] {
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.renew3_payment .yagiprime_check input[type="checkbox"] {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #dfdfdf;
  background: #fff;
  border-radius: 4px;
  vertical-align: -2px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 3px;
}

.renew3_payment .yagiprime_check input[type="checkbox"]:checked:before {
  position: absolute;
  top: -2px;
  left: 4px;
  transform: rotate(50deg);
  width: 8px;
  height: 12px;
  border-right: 3px solid #E3165C;
  border-bottom: 3px solid #E3165C;
  content: '';
}

.renew3_payment .yagiprime_check .check_icon {
  position: relative;
  top: 3px;
  width: auto;
  height: 16px;
  -o-object-fit: cover;
  object-fit: cover;
}

.renew3_payment .yagiprime_check .t_amount {
  margin-left: 20px;
}

.renew3_payment .yagiprime_check .t_terms {
  font-size: 12px;
}

/*共通*/
.renew3_payment .payment_common {
  margin-bottom: 50px;
}

.renew3_payment .payment_common .red_color {
  font-size: 12px;
}

.renew3_payment .payment_common .payment_item {
  border-bottom: 1px solid #dfdfdf;
  padding: 15px;
}

.renew3_payment .payment_common .payment_item:first-child {
  border-top: 1px solid #dfdfdf;
}

.renew3_payment .payment_common .p_contents {
  padding-top: 10px;
}

.renew3_payment .payment_common .p_contentsnone {
  padding-bottom: 0;
}

.renew3_payment .payment_common input[type="radio"] {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #dfdfdf;
  vertical-align: -3px;
  outline: none;
  background-color: #fff;
}

.renew3_payment .payment_common input[type="radio"]::before {
  display: block;
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 9px;
  background-color: #E3165C;
  transform: translate(2px, 2px) scale(0);
  transform-origin: center;
  transition: all 0.3s cubic-bezier(0.25, 0.25, 0.56, 2);
}

.renew3_payment .payment_common input[type="radio"]:checked::before {
  transform: translate(2px, 2px) scale(1);
}

.renew3_payment .payment_common label {
  margin-left: 10px;
  vertical-align: middle;
}

.renew3_payment .payment_common .payment_list {
  margin-left: 0px;
}

.selected-label {
  font-weight: bold;
}

/*金額*/
.renew3_payment .payment_amount {
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  font-weight: bold;
  width: 310px;
  padding: 15px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.renew3_payment .payment_amount .a-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 10px;
}

.renew3_payment .payment_amount .payment-paypay-btn:disabled {
  background: #dfdfdf;
}

.renew3_payment .payment_amount .payment-paypay-btn:disabled:hover {
  cursor: not-allowed;
  background: #dfdfdf;
  opacity: 1;
}

.skeleton-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
}

.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 5px;
}

/* スケルトンのボタンサイズ */
.skeleton-button {
  width: 300px;
  height: 50px;
}

/* スケルトンのアニメーション */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/*メリット*/
.yagiprime_merit {
  margin-bottom: 50px;
}

.yagiprime_merit .yagiprime_merit-h3 {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  margin-bottom: 20px;
}

.yagiprime_merit .yagiprime_merit-list {
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  width: 70%;
}

.yagiprime_merit .yagiprime_merit-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.yagiprime_merit .yagiprime_merit-image {
  width: 124px;
  min-width: 124px;
  height: 100px;
}

/*注意事項*/
.yagiprime_note {
  margin-bottom: 50px;
}

.yagiprime_note .yagiprime_note-h3 {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  margin-bottom: 20px;
}

.yagiprime_note .yagiprime_note-list {
  margin-left: 0;
  margin-bottom: 30px;
  border-radius: 5px;
  padding: 20px 30px;
  background: #fff;
  border: 1px solid #dfdfdf;
  color: #404040;
  height: 200px;
  overflow-y: scroll;
  opacity: 0.8;
}

.yagiprime_note .yagiprime_note-item {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: end;
  -ms-flex-align: end;
  margin-bottom: 15px;
}

.yagiprime_note .item-left {
  font-weight: bold;
}

.yagiprime_note .item-txt {
  font-size: 12px;
}

.p-ApplePayButton {
  min-height: 50px;
}

@media screen and (max-width: 768px) {
  .yagiprime_merit .yagiprime_merit-list {
    width: 100%;
    flex-wrap: nowrap;
    overflow: scroll;
  }
}

/*画面右固定*/

@media screen and (max-width: 768px) {
  .renew3_payment {
    display: block;
  }

  .renew3_payment .how2,
  .renew3_payment .payment_amount {
    width: 100%;
  }

  /*画面下固定*/
  .renew3_payment .payment_amount {
    position: fixed;
    padding-bottom: 25px;
    left: 0;
    bottom: -10px;
    z-index: 5;
    top: auto;
  }
}
</style>
